import React from "react";

const SynonymsTab = ({
  synonymResults,
  synonymLoading,
  synonymQuery,
  onSearchInLyrics,
}) => {
  return (
    <div>
      {synonymLoading && (
        <div className="text-center py-8 text-forest-300">
          Finding synonyms and antonyms...
        </div>
      )}

      {synonymResults && (
        <div className="grid gap-6 md:grid-cols-2 mobile-grid">
          <div className="rounded-lg border p-6 transition-colors bg-forest-800 border-forest-600">
            <h3 className="text-lg font-semibold mb-4 text-forest-100">
              Synonyms for "{synonymQuery}"
            </h3>
            {synonymResults.synonyms.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {synonymResults.synonyms.map((word, index) => (
                  <button
                    key={index}
                    onClick={() => onSearchInLyrics(word.word, "rhymes")}
                    className="px-3 py-1 rounded-full text-sm transition-colors bg-forest-700 hover:bg-forest-600 text-forest-200"
                  >
                    {word.word}
                  </button>
                ))}
              </div>
            ) : (
              <p className="text-forest-300">No synonyms found</p>
            )}
          </div>

          <div className="rounded-lg border p-6 transition-colors bg-forest-800 border-forest-600">
            <h3 className="text-lg font-semibold mb-4 text-forest-100">
              Antonyms for "{synonymQuery}"
            </h3>
            {synonymResults.antonyms.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {synonymResults.antonyms.map((word, index) => (
                  <button
                    key={index}
                    onClick={() => onSearchInLyrics(word.word, "rhymes")}
                    className="px-3 py-1 rounded-full text-sm transition-colors bg-forest-700 hover:bg-forest-600 text-forest-200"
                  >
                    {word.word}
                  </button>
                ))}
              </div>
            ) : (
              <p className="text-forest-300">No antonyms found</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SynonymsTab;
